import { rem } from 'polished';
import styled from '../../theme/styled-components';

export default styled.div`
  font-size: ${rem(32)};
  font-weight: bold;
  margin: 0 0 ${rem(20)} 0;
`;
